export const DOCX_STYLE_MAP: string[] = [
  "p[style-name='Title'] => h1:fresh",
  "p[style-name='Subtitle'] => h6:fresh",
  "p[style-name='Quote'] => blockquote:fresh",
  "p[style-name='Intense Quote'] => blockquote:fresh",
  'u => u',
];
